import { typeUtils } from '@festina-life/core'

import type { DraftCreatedResult, DraftSubmitStatus } from './types'

export const asFailedSubmit = (error: unknown): DraftSubmitStatus => ({
  status: 'error',
  error: typeUtils.isError(error) ? error : new Error(`${error}`),
})

export const draftCreationStatusReporter =
  <TValues>(
    onStatusChanged: (status: DraftSubmitStatus) => void,
    onCreateDraft: (values: TValues) => Promise<DraftCreatedResult>,
  ) =>
  async (values: TValues) => {
    onStatusChanged({ status: 'submitting' })

    try {
      onStatusChanged({ status: 'success', ...(await onCreateDraft(values)) })
    } catch (error) {
      onStatusChanged(asFailedSubmit(error))
    }
  }
